export const rootId = 0;
export const defaultMinDurationMs = 1000;
export const defaultCronSchedule = "0 0 * * * ? *";
